import {getAuthToken} from '../../services/apiClient';

// Single source of truth for the Firebase ID token now lives in
// `services/apiClient.js` (`getAuthToken`). This module re-exports it as
// `getFirebaseToken` so existing importers keep working unchanged — there is
// exactly one token-attach implementation in the codebase.
export const getFirebaseToken = getAuthToken;
